module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "surveyElementSecurityModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SE1000))])]), _vm._v(" "), _c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.surveyElement.name) + ": " + _vm._s(_vm.surveyElement.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-security",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#editorSecurityVisibility",
      "data-toggle": "tab"
    }
  }, [_vm._v(_vm._s(_vm.lang.SE1019))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#editorSecurityReporting",
      "data-toggle": "tab"
    }
  }, [_vm._v(_vm._s(_vm.lang.SE1020))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "editorSecurityTabContent"
    }
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "editorSecurityVisibility"
    }
  }, [_c('div', {
    staticClass: "table-security-settings"
  }, [(_vm.securitySettings.Rules && Object.keys(_vm.securityElements).length > 0) ? _c('table', {
    staticClass: "table table-hover",
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-md-1"
  }, [_vm._v(_vm._s(_vm.lang.SE1036))]), _vm._v(" "), _c('th', {
    staticClass: "col-md-2"
  }, [_vm._v(_vm._s(_vm.lang.SE1021))]), _vm._v(" "), _c('th', {
    staticClass: "col-md-7"
  }, [_vm._v(_vm._s(_vm.lang.SE1022))]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1 text-center"
  }, [_vm._v(_vm._s(_vm.lang.SE1024))]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.securitySettings.Rules), function(rule) {
    return _c('tr', {
      key: rule.RuleNumber
    }, [_c('td', {
      staticClass: "col-md-1 text-left"
    }, [_c('span', {
      staticClass: "rolenumber"
    }, [_vm._v(_vm._s(rule.RuleNumber))])]), _vm._v(" "), _c('td', {
      staticClass: "col-md-2"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('select2', {
      key: ("securityLevelSelect" + (rule.RuleNumber)),
      staticClass: "form-control",
      on: {
        "change": function($event) {
          return _vm.ruleTypeChanged(rule)
        }
      },
      model: {
        value: (rule.RuleType),
        callback: function($$v) {
          _vm.$set(rule, "RuleType", $$v)
        },
        expression: "rule.RuleType"
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }), _vm._v(" "), _vm._l((_vm.securitySettingsStrings), function(text, key) {
      return _c('option', {
        key: key,
        domProps: {
          "value": key
        }
      }, [_vm._v("\n                              " + _vm._s(text) + "\n                            ")])
    })], 2)], 1)]), _vm._v(" "), _c('td', {
      staticClass: "col-md-7"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (rule.RuleType === 'LocationProperty'),
        expression: "rule.RuleType === 'LocationProperty'"
      }],
      staticClass: "form-group nopadding col-12"
    }, [_c('select2', {
      key: ("locationPropertySelect" + (rule.RuleNumber)),
      ref: ("locationPropertySelect" + (rule.RuleNumber)),
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "id": ("locationPropertySelect" + (rule.RuleNumber)),
        "width": "100%",
        "disabled": !rule.RuleType,
        "multiple": false,
        "placeholder": _vm.lang.SE1037
      },
      on: {
        "change": function (d) {
          _vm.ruleValueChanged(rule, d);
        }
      },
      model: {
        value: (rule[rule.RuleType]),
        callback: function($$v) {
          _vm.$set(rule, rule.RuleType, $$v)
        },
        expression: "rule[rule.RuleType ]"
      }
    }, _vm._l((_vm.getElementsForCurrentRuleType(rule.RuleType)), function(element) {
      return _c('option', {
        key: element[_vm.getIdKeyOfRuleType(rule.RuleType)],
        domProps: {
          "value": element[_vm.getIdKeyOfRuleType(rule.RuleType)]
        }
      }, [_vm._v("\n                              " + _vm._s(_vm.getElementName(element)) + "\n                            ")])
    }), 0), _vm._v(" "), _c('div', {
      attrs: {
        "id": "foo"
      }
    }, [_c('select2', {
      key: ("locationPropertyValueSelect" + (rule.RuleNumber)),
      ref: ("locationPropertyValueSelect" + (rule.RuleNumber)),
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "id": ("locationPropertyValueSelect" + (rule.RuleNumber)),
        "width": "100%",
        "multiple": true,
        "placeholder": _vm.lang.SE1037,
        "disabled": !rule[rule.RuleType]
      },
      model: {
        value: (rule['LocationPropertyValue']),
        callback: function($$v) {
          _vm.$set(rule, 'LocationPropertyValue', $$v)
        },
        expression: "rule['LocationPropertyValue']"
      }
    }, _vm._l((_vm.getLocationPropertyValues(rule[rule.RuleType])), function(value, idx) {
      return _c('option', {
        key: idx,
        domProps: {
          "value": value.LocationPropertyValue
        }
      }, [_vm._v("\n                                " + _vm._s(value.LocationPropertyValue) + "\n                              ")])
    }), 0)], 1)], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (rule.RuleType != 'LocationProperty'),
        expression: "rule.RuleType != 'LocationProperty'"
      }],
      staticClass: "form-group nopadding col-12"
    }, [_c('select2', {
      key: ("securityRuleElementSelect" + (rule.RuleNumber)),
      ref: ("securityRuleElementSelect" + (rule.RuleNumber)),
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "width": "100%",
        "id": ("securityRuleElementSelect" + (rule.RuleNumber)),
        "disabled": !rule.RuleType,
        "multiple": true,
        "allowClear": true,
        "placeholder": _vm.lang.SE1037,
        "minimumInputLength": _vm.getElementsForCurrentRuleType(rule.RuleType).length > 500 ? 2 : 0,
        "tags": false
      },
      on: {
        "change": function (d) {
          if (rule.RuleType == 'LocationProperty') { rule[rule.RuleType] = d; }
          _vm.ruleValueChanged(rule);
        }
      },
      model: {
        value: (rule[rule.RuleType]),
        callback: function($$v) {
          _vm.$set(rule, rule.RuleType, $$v)
        },
        expression: "rule[rule.RuleType]"
      }
    }, _vm._l((_vm.getElementsForCurrentRuleType(rule.RuleType)), function(element) {
      return _c('option', {
        key: element[_vm.getIdKeyOfRuleType(rule.RuleType)],
        domProps: {
          "value": element[_vm.getIdKeyOfRuleType(rule.RuleType)]
        }
      }, [_vm._v("\n                              " + _vm._s(_vm.getElementName(element)) + "\n                            ")])
    }), 0)], 1)]), _vm._v(" "), _c('td', {
      staticClass: "col-md-1"
    }, [(rule.RuleType === 'Wave') ? _c('div', {
      staticClass: "checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (rule.WaveFF),
        expression: "rule.WaveFF"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(rule.WaveFF) ? _vm._i(rule.WaveFF, null) > -1 : (rule.WaveFF)
      },
      on: {
        "change": function($event) {
          var $$a = rule.WaveFF,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(rule, "WaveFF", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(rule, "WaveFF", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(rule, "WaveFF", $$c)
          }
        }
      }
    }), _vm._v(" "), _vm._m(0, true)])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "col-md-1"
    }, [_c('button', {
      staticClass: "btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeGeneralSetting(rule.RuleNumber)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("clear")])])])])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row nopadding"
  }, [_c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addNewGeneralSetting()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SE1025) + "\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearGeneralSettings()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SE1026) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "row nopadding"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.securitySettings.Expression),
      expression: "securitySettings.Expression"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "id": "textareaSecuritySettingsExpression",
      "placeholder": ((_vm.lang.SE1038) + ", " + (_vm.lang.SE1039) + ": (1 and 2) or not 3")
    },
    domProps: {
      "value": (_vm.securitySettings.Expression)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
        $event.preventDefault();
        return _vm.globals.insertAtCaret('textareaSecuritySettingsExpression', '\t')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.securitySettings, "Expression", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    class: {
      'validation-error': _vm.validationMessage.Error,
    },
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "id": "validationMessage"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.validationMessage.Msg) + "\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "editorSecurityReporting"
    }
  }, [(Object.keys(_vm.securityGroups).length < 1) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.lang.SE1031) + "\n              ")]) : _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "selectSecurityTargetGroup"
    }
  }, [_vm._v(_vm._s(_vm.lang.SE1030))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSecurityGroup),
      expression: "selectedSecurityGroup"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "selectSecurityTargetGroup"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedSecurityGroup = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.securityGroups), function(name, guid) {
    return _c('option', {
      key: guid,
      domProps: {
        "value": guid
      }
    }, [_vm._v("\n                        " + _vm._s(name) + "\n                      ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "table-security-settings"
  }, [_c('table', {
    staticClass: "table table-hover",
    staticStyle: {
      "margin": "0px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.reportingSettingsStrings), function(title, key) {
    return [(
      key === 'notVisibleInCheckReport' ||
      key === 'uploadVisibleInMediaExplorer' ||
      key === 'notVisibleInRawData'
    ) ? _c('tr', {
      key: key
    }, [_c('td', {
      staticStyle: {
        "padding": "4px"
      }
    }, [_c('div', {
      staticClass: "checkbox",
      staticStyle: {
        "margin": "0px"
      }
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentReportingGroupSettings[key]),
        expression: "currentReportingGroupSettings[key]"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'cb_reportingVisibility_' + key
      },
      domProps: {
        "checked": Array.isArray(_vm.currentReportingGroupSettings[key]) ? _vm._i(_vm.currentReportingGroupSettings[key], null) > -1 : (_vm.currentReportingGroupSettings[key])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.currentReportingGroupSettings[key],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.currentReportingGroupSettings, key, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.currentReportingGroupSettings, key, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.currentReportingGroupSettings, key, $$c)
          }
        }
      }
    }), _vm._v(" "), _vm._m(2, true)])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "16px",
        "padding": "6px"
      }
    }, [_c('label', {
      staticClass: "text-black nopadding",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "role": "button",
        "for": 'cb_reportingVisibility_' + key
      }
    }, [_vm._v(_vm._s(title))])])]) : _vm._e()]
  })], 2)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SE1027) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveSecuritySettings()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SE1028) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticStyle: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "80%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3e7cfbe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SurveyEditor/SurveyElementSecurityModal.vue
// module id = 1727
// module chunks = 1